export default __webpack_public_path__ + "static/media/primary-mobile.3e86b875.jpg";